import "./Schedule.scss";

import { useTranslation } from "react-i18next";

import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";

import ErroCode from "../../assets/images/img_GeneralError_232px.png";
import successImg from "../../assets/images/schedule/img_class-scheduled_success.png";

function AlertModal(props) {
  const { t } = useTranslation();

  const DialogTitle = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing.unit * 2,
      textAlign: "center",
      fontSize: "36px",
      fontWeight: "bold",
      fontFamily: "Quicksand",
      marginTop: "35px",
    },
    closeButton: {
      top: "10px",
      right: "15px",
      color: "#403F4C",
      position: "absolute",
      marginBottom: "24px",
      width: "12px",
      height: "12px",
    },
  }))((props) => {
    const { children, classes, onClose } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  const DialogContent = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing.unit * 2,
    },
  }))(MuiDialogContent);

  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing.unit,
    },
  }))(MuiDialogActions);
  return (
    <Dialog
      open={props.openAlert}
      onClose={props.closeAlert}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" onClose={props.closeAlert}>
        <div
          dangerouslySetInnerHTML={{ __html: props.alertTitle }}
          style={{ color: props.httpCode !== "" ? "#FF5666" : "#004FFF" }}
        />
      </DialogTitle>
      <DialogContent>
        <div className="boxModal">
          <img src={props.httpCode !== "" ? ErroCode : successImg} alt="errorImage" />
          <p className="messageModal">{props.alertMsg}</p>
        </div>
      </DialogContent>
      <DialogActions className="boxModal">
        <Button className="buttons" onClick={() => props.closeAlert(props.httpCode)} color="primary" autoFocus>
          {props.httpCode !== "" ? t("TRY_AGAIN") : t("BTN_CLOSE")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AlertModal;
